enum NodeEnv {
  DEVELOP = `development`,
  PROD = `production`,
  TEST = `test`,
}

export default NodeEnv;
